import React, { Component } from 'react';
import GetTimer from './getTimer';

class getCuentas extends Component {
  constructor(props){
    super(props);
    this.state = {
        cuentas: [],
        loading : false,
        sw_plano: this.props.sw_plano,
        nombre_maquina:this.props.nombre_maquina
    }
  }
  actualizar_cuentas = () =>{
    const url= this.props.url_proxyurl + this.props.url_global;

    fetch(url + 'webservices/getcuentas/'+this.state.nombre_maquina)
    .then(res => res.json())
    .then((data) => {
      this.setState({ cuentas: data, loading:false })
    })
    .catch(console.log)
    this.setState({
      loading:true
    })
  }
  componentDidMount() {
    this.actualizar_cuentas();
    this.props.getEncerarAPI(this.props.nombre_maquina);
  }

  render(){
      let loading;
      const sw_plano = Number(this.state.sw_plano)
      if(this.state.loading){
        loading =<div id="loader" className="loader loader-default is-active" data-text=""></div>
      }
      return (
        <React.Fragment>
        {loading}
        <GetTimer actualizar_cuentas={this.actualizar_cuentas} />
        {(sw_plano!==0)?




          <React.Fragment>
          {this.state.cuentas.map(cuenta_p =>



              <div key={cuenta_p.id_cuenta} style={{"top":cuenta_p.derecha+"%","left":cuenta_p.izquierda+"%","position":"absolute"}}>
                
                
                
                <button  className={cuenta_p.clase+"_pl"} onClick={ () => this.props.Abtn_abrir_cuenta(cuenta_p.id_cuenta,cuenta_p.cuenta,cuenta_p.id_tipo_cuenta,cuenta_p.clase)}>
                {cuenta_p.cuenta}
                </button>
              
              
              
              </div>




            )
          }
          </React.Fragment>




        :
          <React.Fragment>
            {this.state.cuentas.map(cuenta_p =>
                <div key={cuenta_p.id_cuenta} className="css_item_cuenta">
                  <button  className={cuenta_p.clase} onClick={ () => this.props.Abtn_abrir_cuenta(cuenta_p.id_cuenta,cuenta_p.cuenta,cuenta_p.id_tipo_cuenta,cuenta_p.clase)}>
                  {cuenta_p.cuenta}
                  </button>
                </div>
              )
            }
            </React.Fragment>
        }
        </React.Fragment>
      )
  }
}

export default getCuentas;
